module.exports = __webpack_public_path__ + "static/media/footer-logo.51206373.svg";